// src/modules/auth/utils/auth.error.ts
import { AppError, ErrorType, handleError } from "../../../utils/errorHandler";
import { AuthErrorType } from "../types/auth.error.types";

export class AuthError extends AppError {
  authErrorType: AuthErrorType;

  constructor(
    message: string,
    authErrorType: AuthErrorType,
    status: number = 401
  ) {
    super(message, ErrorType.CLIENT, status);
    this.authErrorType = authErrorType;
  }

  static createFromError(error: any): AuthError {
    const appError = handleError(error);

    // Map HTTP status codes to AuthErrorType
    let authErrorType: AuthErrorType;
    switch (appError.status) {
      case 401:
        authErrorType = AuthErrorType.INVALID_CREDENTIALS;
        break;
      case 403:
        authErrorType = AuthErrorType.UNAUTHORIZED;
        break;
      case 400:
        authErrorType = AuthErrorType.REGISTRATION_FAILED;
        break;
      default:
        authErrorType = AuthErrorType.UNAUTHORIZED;
    }

    return new AuthError(appError.message, authErrorType, appError.status);
  }
}

export const handleAuthError = (error: any): AuthError => {
  if (error instanceof AuthError) {
    return error;
  }
  return AuthError.createFromError(error);
};

export type { AuthErrorType };
